const config = {
    apiBaseUrl: process.env.VUE_APP_API_BASE_URL,
    apiVersion:process.env.VUE_APP_API_VERSION,
    apiUrl:process.env.VUE_APP_API_BASE_URL+process.env.VUE_APP_API_VERSION,
}
  
  export default config;